// SearchContext.js
import React, { createContext, useContext, useState } from 'react';

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState(null);
  const [resultLoading, setResultLoading] = useState(false);

  return (
    <SearchContext.Provider value={{ searchTerm, setSearchTerm, resultLoading, setResultLoading }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  return useContext(SearchContext);
};